export const SET_AUTOMATION = "SET_AUTOMATION";
export const SET_AUTOMATIONS = "SET_AUTOMATIONS";
export const ADD_AUTOMATION = "ADD_AUTOMATION";
export const UPDATE_AUTOMATION = "UPDATE_AUTOMATION";
export const DELETE_AUTOMATION = "DELETE_AUTOMATION";
